import styles from "./loaders.module.css";

const ROW_WIDTHS = ["62%", "48%", "70%", "40%", "55%", "35%"];
const LINE_WIDTHS = ["100%", "96%", "88%", "92%", "70%", "100%", "60%"];

/**
 * Skeleton shown on the Email Templates list page while the table data loads.
 * Mirrors the real toolbar + table layout, including the mobile card view.
 */
export const EmailTemplateListLoader = () => {
    return (
        <>
            <div className={styles.HeaderWrap}>
                <div className={styles.HeaderLeft}>
                    <div className={`${styles.Bone} ${styles.TitleBone}`} />
                </div>
                <div className={`${styles.Bone} ${styles.BreadcrumbBone}`} />
            </div>

            <div className={styles.ListToolbar}>
                <div className={`${styles.Bone} ${styles.SearchBone}`} />
                <div className={`${styles.Bone} ${styles.ButtonBone}`} />
            </div>

            <div className={styles.ListBody}>
                {ROW_WIDTHS.map((width, index) => (
                    <div className={styles.ListRow} key={index}>
                        <div className={`${styles.Bone} ${styles.RowTitleBone}`} style={{ width }} />
                        <div className={styles.RowActions}>
                            <div className={`${styles.Bone} ${styles.ActionBone}`} />
                            <div className={`${styles.Bone} ${styles.ActionBone}`} />
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

/**
 * Skeleton shown on the Email Template preview page while the template loads.
 * Mirrors the header (back button + title) and a mocked email body.
 */
export const EmailTemplatePreviewLoader = () => {
    return (
        <>
            <div className={styles.HeaderWrap}>
                <div className={styles.HeaderLeft}>
                    <div className={`${styles.Bone} ${styles.CircleBone}`} />
                    <div className={`${styles.Bone} ${styles.TitleBone}`} />
                </div>
                <div className={`${styles.Bone} ${styles.BreadcrumbBone}`} />
            </div>

            <div className={styles.PreviewBody}>
                <div className={styles.PreviewFrame}>
                    <div className={`${styles.Bone} ${styles.LogoBone}`} />
                    <div className={`${styles.Bone} ${styles.HeadingBone}`} />
                    {LINE_WIDTHS.map((width, index) => (
                        <div className={`${styles.Bone} ${styles.LineBone}`} key={index} style={{ width }} />
                    ))}
                </div>
            </div>
        </>
    );
};